import { type AddressType, getRoundedValueOfPercentage } from '@sg/garnish';

import { type FeatureFlags } from '@order/LaunchDarkly';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Given the dynamic tips configured in launch darkly for this order type and the initial order subtotal,
 * Return the dollar amount of the default tip and the available tip values.
 * The component that manages the tips does not need to concern itself with the default tip or with the order channel.
 */
export const getTips = (params: TippingParams) => {
  const { maxTipAmount, orderChannel, dynamicTips } = params;

  const tips = dynamicTips?.[orderChannel] ?? [];

  const defaultTipObject = tips.find((tip) => tip?.isDefault) ?? tips[0];
  const defaultTipValue = Number(defaultTipObject?.value);
  const defaultTip = Number.isNaN(defaultTipValue) ? 0 : defaultTipValue;

  const selectedTip = getRoundedValueOfPercentage(defaultTip, maxTipAmount);

  return {
    selectedTip,
    availableTips: tips
      .filter((tip) => tip?.value !== undefined)
      .map((tip) => tip?.value) as ReadonlyArray<number | 'CUSTOM'>,
  };
};

// ─── Types ──────────────────────────────────────────────────────────────────

type DynamicTips = FeatureFlags['CELS-1191-permanent-dynamic-tip-values'];
type TippingParams = {
  maxTipAmount: number;
  orderChannel: AddressType;
  dynamicTips: DynamicTips;
};
